export const COMPLETE_APPROVAL_MODE = "complete_package";
export const PER_LOCATION_APPROVAL_MODE = "per_location";

export const APPROVAL_MODE_ORDER = [
  COMPLETE_APPROVAL_MODE,
  PER_LOCATION_APPROVAL_MODE,
];

export const deriveInitialApprovalMode = (response = {}) => {
  const mappings = Array.isArray(response?.mappings) ? response.mappings : [];
  const hasCompletePackageMappings = mappings.some(
    (mapping) => String(mapping?.approvalMode || "").trim() === COMPLETE_APPROVAL_MODE
  );
  if (hasCompletePackageMappings) {
    return COMPLETE_APPROVAL_MODE;
  }

  const hasPerLocationMappings = mappings.some(
    (mapping) => String(mapping?.approvalMode || "").trim() === PER_LOCATION_APPROVAL_MODE
  );
  if (hasPerLocationMappings) {
    return PER_LOCATION_APPROVAL_MODE;
  }

  const explicitMode = String(response?.activeApprovalMode || "").trim();
  if (explicitMode === COMPLETE_APPROVAL_MODE) {
    return COMPLETE_APPROVAL_MODE;
  }

  return COMPLETE_APPROVAL_MODE;
};
